module.exports = __webpack_public_path__ + "static/media/avatar-3.a2ff93e7.svg";